module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    attrs: {
      "title": "流程流向"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('el-checkbox', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAll),
      expression: "checkAll"
    }],
    attrs: {
      "isIndeterminate": _vm.isIndeterminate
    },
    domProps: {
      "value": (_vm.checkAll)
    },
    on: {
      "change": _vm.handleCheckAllChange,
      "input": function($event) {
        _vm.checkAll = $event
      }
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0"
    }
  }), _vm._v(" "), _vm._l((_vm.currentData.currentContent), function(item, index) {
    return _c('div', {
      key: item,
      staticClass: "m-l-20"
    }, [_c('el-checkbox', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selected),
        expression: "item.selected"
      }],
      attrs: {
        "label": item
      },
      domProps: {
        "value": (item.selected)
      },
      on: {
        "change": function($event) {
          _vm.handleGruopChange(index, $event)
        },
        "input": function($event) {
          item.selected = $event
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.name) + "\n      ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "15px 0"
      }
    }), _vm._v(" "), _vm._l((item.list), function(childItem) {
      return _c('el-checkbox', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (childItem.selected),
          expression: "childItem.selected"
        }],
        key: childItem,
        staticClass: "m-l-20",
        staticStyle: {
          "padding": "5px"
        },
        attrs: {
          "label": childItem
        },
        domProps: {
          "value": (childItem.selected)
        },
        on: {
          "change": function($event) {
            _vm.handleChildChange(index)
          },
          "input": function($event) {
            childItem.selected = $event
          }
        }
      }, [_vm._v("\n      " + _vm._s(childItem.realname) + "\n      ")])
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "15px 0"
      }
    })], true)
  })], true), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedId.length === 0
    },
    on: {
      "click": function($event) {
        _vm.submitData()
      }
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-62d5e5dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Flow/instance/flowProcessDialog.vue
// module id = 1887
// module chunks = 2